import { useFastCheckoutContext } from "@/components/Checkout/CheckoutMachine";
import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import { Box, styled } from "@mui/material";
import { useSelector } from "@xstate/react";
import moment from "moment";

const PurchaseSummary = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: "20px",
  ".info_sum_title": {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 10,

    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
      marginBottom: 4,
    },
  },
  ".info_sum_value": {
    fontSize: 16,
    fontWeight: 500,
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
  },
}));

const RetailerSummarySection = () => {
  const { actorRef } = useFastCheckoutContext();
  const order = useSelector(
    actorRef,
    (state) =>
      state.context.retailerCheckoutOrderStatus?.userRetailerCheckoutOrder
  );

  const totalProductQuantity = order?.items.reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  return (
    <Box
      className="section"
      sx={{
        ".title": {
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      }}
    >
      <div className="section_body">
        <PurchaseSummary>
          <div className="order-detail__section">
            <div className="info_sum_title">Ordered</div>
            <div className="info_sum_value">
              {moment(order?.createdTime).format("MMM DD, YYYY")}
            </div>
          </div>
          <div className="order-detail__section">
            <div className="info_sum_title">Items</div>
            <div className="info_sum_value">{order?.items.length}</div>
          </div>
          <div className="order-detail__section">
            <div className="info_sum_title">Quantity</div>
            <div className="info_sum_value">{totalProductQuantity}</div>
          </div>
        </PurchaseSummary>
      </div>
    </Box>
  );
};

export default RetailerSummarySection;
